import { render, staticRenderFns } from "./DynamicResidentialProxy.vue?vue&type=template&id=b8fa523c&scoped=true"
import script from "./DynamicResidentialProxy.vue?vue&type=script&lang=js"
export * from "./DynamicResidentialProxy.vue?vue&type=script&lang=js"
import style0 from "./DynamicResidentialProxy.vue?vue&type=style&index=0&id=b8fa523c&prod&lang=less"
import style1 from "./DynamicResidentialProxy.vue?vue&type=style&index=1&id=b8fa523c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_8432db7643500554ffee61cb980ae8ea/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8fa523c",
  null
  
)

export default component.exports